import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const payNinetyPreviewFunction = createAsyncThunk(
  "preview/payNinetyPreviewFunction",
  async (
    { construction_preview_id },
    { rejectWithValue }
  ) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/pay_90`,
        { construction_preview_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.status) {
        return rejectWithValue(response.message);
      }

      return response.data;
    } catch (error) {
      console.error("Error pay preview:", error.message);

      const errorMessage = error.response || "Failed to pay preview";

      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  payNinetyPreview: null,
  status: "idle",
  error: null,
};

const payNinetyPreviewSlice = createSlice({
  name: "payNinetyPreview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(payNinetyPreviewFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(payNinetyPreviewFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.payNinetyPreview = action.payload;
      })
      .addCase(payNinetyPreviewFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default payNinetyPreviewSlice.reducer;
